import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnInit } from '@angular/core';

import { IFsAddressConfig, FsAddressModule } from '@firestitch/address';

import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { EnvironmentCreate } from '../../interfaces';
import { FsSkeletonModule } from '@firestitch/skeleton';
import { FormsModule } from '@angular/forms';
import { FsFormModule } from '@firestitch/form';
import { MatCardContent, MatCardActions } from '@angular/material/card';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FsSkeletonModule,
        FormsModule,
        FsFormModule,
        MatCardContent,
        FsAddressModule,
        MatCardActions,
        MatButton,
    ],
})
export class AddressComponent implements OnInit {

  @Input() public environmentCreate: EnvironmentCreate = null;

  @Output() public environmentCreateChange = new EventEmitter<EnvironmentCreate>();

  public config: IFsAddressConfig = {
    label: 'Address',
    street: { required: false },
    city: { required: true },
    region: { required: true },
    country: { required: true },
    zip: { required: false },
  };

  constructor() { }

  public ngOnInit(): void {
  }

  public save = () => {
    return of(this.environmentCreate)
      .pipe(
        tap((response) => this.environmentCreateChange.emit(response)),
      );
  };
}
